import { render } from "./ConsumptionGauge.vue?vue&type=template&id=2db20838&scoped=true"
import script from "./ConsumptionGauge.vue?vue&type=script&lang=js"
export * from "./ConsumptionGauge.vue?vue&type=script&lang=js"

import "./ConsumptionGauge.vue?vue&type=style&index=0&id=2db20838&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db20838"]])

export default __exports__